import { render } from "./PostBottomSheet.vue?vue&type=template&id=0f2c41aa&scoped=true"
import script from "./PostBottomSheet.vue?vue&type=script&lang=js"
export * from "./PostBottomSheet.vue?vue&type=script&lang=js"

import "./PostBottomSheet.vue?vue&type=style&index=0&id=0f2c41aa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f2c41aa"]])

export default __exports__